import JAS_LOGO from "../assets/JAS_LOGO.avif";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import UserGuide from "./UserGuide";

const LandingPage = () => {
  const navigate = useNavigate();
  return (
    <div className="jas-landing">
      {/* HEADER */}
      <header className="jas-header">
        <a href="/">
          <img src={JAS_LOGO} alt="JAS Communications Logo" className="jas-header-logo" />
        </a>
        <div className="jas-header-actions">
          <Button className="jas-outline-btn" onClick={() => navigate("/login")}>
            Integrate to Zoho CRM
          </Button>
          <Button className="jas-cta-btn" onClick={() => navigate("/signup")}>
            Sign Up
          </Button>
        </div>
      </header>

      {/* HERO */}
      <section className="jas-hero">
        <div className="jas-hero-content">
          <p className="jas-eyebrow">Zoho CRM Integration</p>
          <h1 className="jas-hero-title">JAS Communications</h1>
          <p className="jas-hero-sub">
            The Insurance Industry's Most Trusted Phone System — now seamlessly
            connected to Zoho CRM via PhoneBridge.
          </p>
          <div className="jas-hero-btns">
            <Button className="jas-cta-btn" onClick={() => navigate("/signup")}>
              Sign Up
            </Button>
            <Button className="jas-outline-btn" onClick={() => navigate("/login")}>
              Integrate to Zoho CRM
            </Button>
          </div>
        </div>
        <div className="jas-hero-visual">
          <div className="jas-feature-card">
            <span className="jas-feature-icon">📞</span>
            <span>Click-to-Call from Zoho</span>
          </div>
          <div className="jas-feature-card">
            <span className="jas-feature-icon">🔔</span>
            <span>Incoming Call Pop-ups</span>
          </div>
          <div className="jas-feature-card">
            <span className="jas-feature-icon">📋</span>
            <span>Auto Call Logging</span>
          </div>
          <div className="jas-feature-card">
            <span className="jas-feature-icon">🎙️</span>
            <span>Call Recordings & History</span>
          </div>
        </div>
      </section>

      {/* ZOHO INTEGRATION */}
      <section className="jas-integration">
        <div className="jas-integration-inner">
          <p className="jas-eyebrow">Zoho CRM</p>
          <h2>What the Integration Unlocks</h2>
          <div className="jas-integration-grid">
            <div className="jas-integration-item">
              <span className="jas-integration-icon">⚡</span>
              <h3>Click-to-Call</h3>
              <p>Dial any contact directly from Zoho CRM with a single click.</p>
            </div>
            <div className="jas-integration-item">
              <span className="jas-integration-icon">💬</span>
              <h3>Caller Context Pop-ups</h3>
              <p>See full customer details the moment an inbound call arrives.</p>
            </div>
            <div className="jas-integration-item">
              <span className="jas-integration-icon">📁</span>
              <h3>Automatic Call Logging</h3>
              <p>Every call is recorded and synced to the right CRM record instantly.</p>
            </div>
            <div className="jas-integration-item">
              <span className="jas-integration-icon">📊</span>
              <h3>Call History & Recordings</h3>
              <p>Access real-time call history and recordings directly in Zoho.</p>
            </div>
          </div>
        </div>
      </section>

      {/* USER GUIDE */}
      <section className="jas-guide">
        <div className="jas-guide-inner">
          <p className="jas-eyebrow">How It Works</p>
          <h2>Integration Setup Guide</h2>
          <UserGuide />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="jas-footer">
        <div className="jas-footer-inner">
          <div className="jas-footer-brand">
            <img src={JAS_LOGO} alt="JAS Communications Logo" className="jas-footer-logo" />
            <p className="jas-footer-tagline">
              The Insurance Industry's Most Trusted Phone System
            </p>
            <div className="jas-footer-socials">
              <a href="https://www.facebook.com/people/JAS-Communications/100088859319755/" target="_blank" rel="noreferrer">Facebook</a>
              <a href="https://www.linkedin.com/company/jas-communications/" target="_blank" rel="noreferrer">LinkedIn</a>
            </div>
          </div>

          <div className="jas-footer-contact">
            <h3>Contact & Support</h3>
            <p><strong>Email:</strong> <a href="mailto:sales@jascommunications.com">sales@jascommunications.com</a></p>
            <p><strong>Support:</strong> <a href="mailto:support@jascommunications.com">support@jascommunications.com</a></p>
            <p><strong>Phone:</strong> <a href="tel:+15146133395">+1 (514) 613-3395</a></p>
          </div>

          <div className="jas-footer-links">
            <h3>Legal</h3>
            <a href="https://www.jascommunications.ca/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>
            <a href="https://www.jascommunications.ca/terms-conditions/" target="_blank" rel="noreferrer">Terms & Conditions</a>
          </div>
        </div>

        <div className="jas-footer-bottom">
          <p>© {new Date().getFullYear()} JAS Communications. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
